/** Parallel S3 uploads during local bulk folder ingest (keep low to avoid s3-utils 429). */
export const BULK_UPLOAD_S3_CONCURRENCY = Number(import.meta.env.VITE_BULK_UPLOAD_CONCURRENCY) || 2

/** Pause between starting each S3 upload (ms). */
export const BULK_UPLOAD_S3_DELAY_MS = Number(import.meta.env.VITE_BULK_UPLOAD_DELAY_MS) || 250

/** store-files / check-existing chunk size (must match backend). */
export const BULK_UPLOAD_STORE_CHUNK_SIZE = 500

/** check-resume chunk size — parallel requests/queries for faster processed-file lookup. */
export const BULK_UPLOAD_CHECK_CHUNK_SIZE = 500

/** Parallel check-resume requests from the browser. */
export const BULK_UPLOAD_CHECK_CONCURRENCY =
  Number(import.meta.env.VITE_BULK_UPLOAD_CHECK_CONCURRENCY) || 6
